// extracted by mini-css-extract-plugin
module.exports = {"totpQrcode":"Totp__totpQrcode___1crLx"};


// WEBPACK FOOTER //
// ./webpack:/aws_amplify_ui/src/Totp.css?55f1